import { render, staticRenderFns } from "./OwnerInformation.vue?vue&type=template&id=92e79888"
import script from "./OwnerInformation.vue?vue&type=script&lang=ts"
export * from "./OwnerInformation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports